import { FormattedMessage } from "react-intl";

import AccountCreation from "@/components/signup/account-creation";
import { SignupBackgroundLayout } from "@/components/signup/layouts";

import { GetStartedHeading, SubHeading } from "../components";

import { TeamworkCollectionLogo } from "./components/teamwork-collection-logo";

export const LoggedOut = () => (
    <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
        <GetStartedHeading productName="Teamwork Collection" />
        <SubHeading>
            <FormattedMessage
                id="signup.teamworkCollection.subHeading"
                defaultMessage="It’s free for up to 10 users - no credit card needed."
            />
        </SubHeading>
        <AccountCreation />
    </SignupBackgroundLayout>
);
